var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"content"},[_c('base-header',{attrs:{"name":_vm.user_name,"topOnly":_vm.flag_top,"account_list":_vm.account_list}}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.user_name || ''))]),_vm._v(" "),_c('div',{staticClass:"jd"},[_vm._v("当前账号酒豆余额："),_c('span',[_vm._v(_vm._s(_vm.money2))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e18cce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/luckyPlayer.vue
// module id = null
// module chunks = 